import { render, staticRenderFns } from "./PaymentFeature.vue?vue&type=template&id=11986ece&"
import script from "./PaymentFeature.vue?vue&type=script&lang=js&"
export * from "./PaymentFeature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports